<div class="flex flex-col gap-2">
  @if (store.campaignsError$()) {
    <div class="flex flex-col items-center gap-2 py-4" data-testid="creator-details-deliverables-campaigns-error">
      <span class="opacity-50 text-center">{{
        'pages.creatorDetails.deliverables.campaignsLoadError' | translate
      }}</span>
      <button mat-flat-button (click)="onRetryCampaigns()">
        {{ 'pages.creatorDetails.deliverables.retry' | translate }}
      </button>
    </div>
  } @else {
    <span class="text-sm mb-1">
      {{ 'pages.campaignDetails.deliverables.filters.title' | translate }}
    </span>

    <div class="flex items-center gap-4 w-fill-available pl-1">
      <!-- initialState is read once at the picker's ngOnInit, so it waits for the resolved (persisted or default) range -->
      @if (dateFilterState()) {
        <app-profile-date-filter
          class="w-[252px]"
          data-testid="creator-details-deliverables-date-filter"
          [allTimeBounds]="fullPeriodBounds()"
          [campaignAnalytics]="null"
          [initialState]="dateFilterState()"
          [loading]="scopeLoading()"
          [translationKeyPrefix]="'pages.creatorDetails.deliverables.filter'"
          (dateRangeChanged)="onDateRangeChanged($event)"
          (selectedRangeChanged)="onSelectedRangeChanged($event)"
        />
      } @else {
        <ngx-skeleton-loader
          class="h-[34px] w-[252px]"
          [theme]="{ height: '34px', width: '100%', 'border-radius': '100vw' }"
        />
      }

      <app-profile-platform-feature-select
        class="w-[252px]"
        data-testid="creator-details-deliverables-platform-filter"
        [campaignAnalytics]="store.scopeCampaignAnalytics$()"
        [initialSelectedPlatformFeatures]="draftPlatformFeatures()"
        [loading]="scopeLoading()"
        (platformFeaturesChanged)="onPlatformFeaturesChanged($event)"
        (selectionNormalized)="onPlatformFeaturesNormalized($event)"
        (panelClosed)="onPlatformFeaturesPanelClosed()"
      />

      <app-profile-campaign-filter
        class="w-[252px]"
        data-testid="creator-details-deliverables-campaign-filter"
        [campaigns]="store.campaigns$()"
        [initialSelectedCampaignIds]="draftCampaignIds()"
        [loading]="scopeLoading()"
        (campaignIdsChanged)="onCampaignIdsChanged($event)"
        (selectionNormalized)="onCampaignIdsNormalized($event)"
        (panelClosed)="onCampaignIdsPanelClosed()"
      />
    </div>

    @if (store.error$()) {
      <div class="flex justify-center w-full" data-testid="creator-details-deliverables-error">
        <span class="opacity-50 text-center">{{ 'pages.creatorDetails.deliverables.loadError' | translate }}</span>
      </div>
    }

    <app-campaign-details-deliverables
      class="block w-fill-available"
      data-testid="creator-details-deliverables-table"
      [campaignExportConfig]="campaignExportConfig()"
      [contextColumn]="'campaign'"
      [storageKeyPrefix]="'creator-details'"
      [campaignIconById]="campaignIconById()"
      [campaignNameById]="campaignNameById()"
      [analyticsNodes]="effectiveAnalyticsNodes()"
      [loading]="store.loading$()"
      [hideTitleAndDescription]="true"
      (deliverableRowClicked)="onDeliverableRowClicked($event)"
      (deliverableRowGroupClicked)="onDeliverableRowGroupClicked($event)"
      (campaignClicked)="onCampaignClicked($event)"
    />
  }
</div>
